import { useContext, useEffect } from "react";
import Modal from "./components/Modal";
import StartButton from "./components/StartButton";
import { ModalContext } from "./contexts/ModalContext";
import Screens from "./Screens";

function App() {
  // const [modalOpen, , , close] = useContext(ModalContext);
  const [modalOpen, ,open , close, isElementActive] = useContext(ModalContext);

  useEffect(() => {
    // if (!modalOpen) {
    //   console.log(window.devicePixelRatio);
    //   if (window.devicePixelRatio !== 1) {
    //     document.body.style.zoom = (1 / 1).toString();
    //   }
    // }
  }, [isElementActive]);

  return (
    <>
      {isElementActive && !modalOpen && <StartButton modalOpen={modalOpen} open={open} close={close} />}
      {modalOpen && (
        <Modal modalOpen={modalOpen} handleClose={close}>
          <Screens />
        </Modal>
      )}
    </>
  );
}

export default App;
